import { TipoBensServicos } from "./TipoBensServicos";

export class BemServico {
    idBensServicos: any;
    nmBensServicos: any;
    dsBensServicos: any;
    tipoBensServicos: TipoBensServicos;

    constructor() {
        this.idBensServicos = "";
        this.nmBensServicos = "";
        this.dsBensServicos = "";
        this.tipoBensServicos = new TipoBensServicos();
    }

    public setIrregularidade(bensServicosInfo){
        this.idBensServicos = bensServicosInfo.idBensServicos;
        this.nmBensServicos = bensServicosInfo.nmBensServicos;
        this.dsBensServicos = bensServicosInfo.dsBensServicos;
        this.tipoBensServicos = bensServicosInfo.tipoBensServicos;
    }

}



// WEBPACK FOOTER //
// ./src/models/BemServico.ts